import React, {Component} from "react"

import id from "@irati/utils/id"
import ErrorText from "@irati/ui/src/ErrorText"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {Hidden} from "@irati/ui/src/FormItem"
import {Recognition as RecognitionField} from "@irati-web/fields/poll/votes"
import {validatedScreen} from "@irati/utils/validation"
import {recognitionSchema} from "@irati-web/fields/poll/votes/validation"
import UpdateRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Update"
import {Recognition} from "@irati/types"
import {Form} from "../shared/layouts"
import {ButtonsContainer, CancelButton, ValidationButton} from "../shared/Buttons"

interface Props extends InjectIntl {
  id?: string
  recognition: Recognition
  onClickCancel: () => void
  onUpdateSuccess: () => void
}

interface State {
  message: string
}

class UpdateRecognition extends Component<Props, State> {
  static defaultProps = {
    id: "update-recognition"
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      message: props.recognition.message
    }
  }

  handleChange = (message: string) => this.setState({message})

  render() {
    const {intl, recognition, onClickCancel, onUpdateSuccess} = this.props
    const {message} = this.state

    return (
      <UpdateRecognitionMutation recognition={recognition} newMessage={message} onCompleted={onUpdateSuccess}>
        {(onClick, apolloState) => (
          <Form>
            <RecognitionField onChange={this.handleChange} value={message} />
            <Hidden
              id={id("hidden-recognition", this.props)}
              name={id("hidden-recognition", this.props)}
              value={message}
              validation={recognitionSchema(intl)}
            />
            {apolloState.error && (
              <div>
                <ErrorText>{apolloState.errorMsg}</ErrorText>
              </div>
            )}
            <ButtonsContainer>
              <CancelButton id={id("cancel", this.props)} type="button" onClick={onClickCancel}>
                <FormattedMessage id="recognition.popup.recognition.updateRecognition.cancelButton" />
              </CancelButton>
              <ValidationButton id={id("submit", this.props)} onClick={onClick} apolloState={apolloState} full primary>
                <FormattedMessage id="recognition.popup.recognition.updateRecognition.saveButton" />
              </ValidationButton>
            </ButtonsContainer>
          </Form>
        )}
      </UpdateRecognitionMutation>
    )
  }
}

export default injectIntl(validatedScreen(UpdateRecognition, "UpdateRecognition"))
